/* SoBe search (2026-10-09)
 *
 * 1. PRECISE RESULTS. On submit, "coffee table" is sent as  title:coffee title:table .
 *    Shopify's field-scoped search ANDs the words against product titles: 61 coffee tables,
 *    instead of the 385 mixed products the plain query returns (it ORs the words, so every
 *    "table" and every "coffee" description matched). Size/colour/material/room words are
 *    sent as plain words, which Shopify uses only to rank ("king bed" -> every bed, King
 *    first). If the precise query finds nothing, templates/search.liquid falls straight back
 *    to the plain query with Shopify's native prefix matching (options[prefix]=last), so a
 *    search can never dead-end.
 *    This replaces the old "*" wildcard hook in custom.js: "lilly*" made Shopify match
 *    893 of 904 products (Kelly, Milly, Lulu...), while plain "lilly" returns the 6 Lilly pieces.
 *
 * 2. TYPE-AHEAD. As you type, a dropdown shows predicted searches, matching collections and
 *    products from Shopify's /search/suggest.json. Products whose titles contain every typed
 *    word are shown first; Shopify's own matches only appear when nothing matches by title
 *    (so "couch" still finds sofas).
 *
 * Progressive enhancement: if this file fails to load or throws, the search forms submit a
 * plain query and work exactly as Shopify's default search does.
 */
(function () {
  // sobe-cj-search (2026-10-13): COUTURE Jardin quick-ship pieces stay out of on-site search (Frank); Google still indexes them.
  // sobe-incanto-search (2026-10-23): Incanto special orders are hidden from on-site search too (Frank); Google still indexes them.
  var SOBE_EXCL = '-vendor:"Couture Jardin" -vendor:"Incanto" ';
  'use strict';
  if (window.__sobeSearch) { return; }
  window.__sobeSearch = true;

  /* ------------------------------------------------------------------ query building */

  var STOPWORDS = { and: 1, or: 1, not: 1, the: 1, a: 1, an: 1, with: 1, for: 1, of: 1, in: 1, on: 1, to: 1, by: 1, my: 1 };

  // Two-word phrases shoppers type that the catalog writes as one word.
  var PHRASES = [
    [/\blove\s+seats?\b/g, 'loveseat'],
    [/\bnight\s+stands?\b/g, 'nightstand'],
    [/\bbook\s*shel(f|ves)\b/g, 'bookcase'],
    [/\bbar\s*stools?\b/g, 'barstool'],
    [/\bsectional\s+sofas?\b/g, 'sectional'],
    [/\bliving\s+rooms?\b/g, 'room'],
    // media pieces are named "TV Stand", "TV Unit", "Entertainment Wall Unit", "Media ..."
    [/\b(tv|media)\s+(stand|console|cabinet|unit|center|centre|table)s?\b/g, 'tvword tvpiece'],
    [/\bentertainment\s+(center|centre|unit|console|wall)s?\b/g, 'tvwall'],
    // "accent table" = the side, end and accent tables
    [/\baccent\s+tables?\b/g, 'accenttable table']
  ];

  // Word -> title words that mean the same thing in this catalog (checked against live titles:
  // no title says couch/carpet/sideboard/patio/headboard/kitchen; 20 say Armchair and 6
  // Barstool, which "chair"/"stool" would otherwise miss because title: matches whole words).
  // The typed word comes first so the results page can show it back.
  var SYNONYMS = {
    couch: ['couch', 'sofa', 'loveseat'],
    couches: ['couch', 'sofa', 'loveseat'],
    gray: ['gray', 'grey'],
    grey: ['grey', 'gray'],
    chair: ['chair', 'armchair'],
    chairs: ['chair', 'armchair'],
    stool: ['stool', 'barstool'],
    stools: ['stool', 'barstool'],
    barstool: ['barstool', 'stool'],
    carpet: ['carpet', 'rug'],
    carpets: ['carpet', 'rug'],
    sideboard: ['sideboard', 'buffet'],
    sideboards: ['sideboard', 'buffet'],
    credenza: ['credenza', 'buffet'],
    patio: ['patio', 'outdoor'],
    headboard: ['headboard', 'bed'],
    headboards: ['headboard', 'bed'],
    kitchen: ['kitchen', 'dining'],
    accenttable: ['accent', 'side', 'end'],
    tvword: ['tv', 'media'],
    tvpiece: ['stand', 'unit', 'console', 'cabinet', 'center'],
    tvwall: ['entertainment', 'tv', 'media'],
    lily: ['lily', 'lilly']
  };

  // Words that describe a version of a thing (size, colour, shape, material, style) rather than
  // the thing itself. They are sent as plain words next to the title-scoped ones, which Shopify
  // treats as "rank these first" instead of "must match": "king bed" -> title:bed king returns
  // all 42 beds with the King-named ones on top (most beds offer King as a size option, so it
  // is not in their names). A query made only of these words is scoped as usual ("walnut").
  var MODIFIERS = {
    white: 1, black: 1, gray: 1, grey: 1, beige: 1, cream: 1, ivory: 1, brown: 1, tan: 1, taupe: 1,
    blue: 1, navy: 1, green: 1, red: 1, pink: 1, gold: 1, silver: 1, bronze: 1, natural: 1, dark: 1, light: 1,
    king: 1, queen: 1, full: 1, twin: 1, cal: 1, california: 1, small: 1, large: 1, big: 1,
    round: 1, square: 1, rectangular: 1, rectangle: 1, oval: 1, curved: 1,
    leather: 1, fabric: 1, velvet: 1, linen: 1, boucle: 1, marble: 1, travertine: 1, ceramic: 1,
    porcelain: 1, glass: 1, wood: 1, wooden: 1, walnut: 1, oak: 1, metal: 1, stone: 1, lacquer: 1,
    gloss: 1, chrome: 1, steel: 1,
    charcoal: 1, espresso: 1, chocolate: 1, camel: 1, champagne: 1, cognac: 1, olive: 1, sage: 1,
    rust: 1, mustard: 1, emerald: 1, teal: 1, brass: 1, copper: 1, teak: 1, rattan: 1, wicker: 1,
    aluminum: 1, nickel: 1,
    modern: 1, contemporary: 1, italian: 1, luxury: 1, designer: 1, custom: 1, new: 1
  };

  // Context words: never required, only rank. No product name says "furniture" or "room"
  // ("dining room table", "office furniture"), and every product's vendor is "SoBe Furniture",
  // so as required words they matched everything or nothing. A query made only of these is
  // sent as typed.
  var CONTEXT = {
    furniture: 1, furnitures: 1, sobe: 1, home: 1, room: 1, rooms: 1, set: 1, sets: 1,
    frame: 1, frames: 1, seater: 1, seaters: 1, piece: 1, pieces: 1, pc: 1
  };

  // Words whose products rarely carry the word in their names but have a clean product type
  // (the Pebl outdoor range is typed "Outdoor Sofas", "Outdoor Dining Chairs"...). Matched on
  // title OR product type. Kept deliberately short: product_type is unreliable elsewhere
  // (a platform bed is typed "Coffee Tables").
  var TYPE_WORDS = { outdoor: 1 };

  function normalize(raw) {
    var s = (raw || '').toLowerCase();
    for (var i = 0; i < PHRASES.length; i++) { s = s.replace(PHRASES[i][0], PHRASES[i][1]); }
    return s;
  }

  // Letters (incl. accented) and digits only; everything else separates words.
  function tokenize(raw) {
    return normalize(raw)
      .replace(/[^a-z0-9\u00c0-\u024f]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(function (w) { return w && !STOPWORDS[w] && (w.length > 1 || /\d/.test(w)); });
  }

  function alternatives(word) { return SYNONYMS[word] || [word]; }

  // Split tokens into the words that must be in the product name (core) and the ones that only
  // rank (mods). Bare numbers are left out of the query when a name word is present: Shopify
  // treats a plain number as required anywhere in the product, so "140 sectional" found nothing
  // and "60 round dining table" kept an arbitrary third of the tables. "370" alone stays scoped.
  function isNum(w) { return /^\d+$/.test(w); }
  function splitWords(tokens) {
    var nums = tokens.filter(isNum);
    var ctx = tokens.filter(function (w) { return CONTEXT[w]; });
    var mods = tokens.filter(function (w) { return MODIFIERS[w]; });
    var core = tokens.filter(function (w) { return !isNum(w) && !CONTEXT[w] && !MODIFIERS[w]; });
    if (core.length) { return { core: core, mods: mods.concat(ctx), nums: nums }; }
    if (mods.length) { return { core: mods.concat(nums), mods: ctx, nums: [] }; }   // "walnut", "italian furniture"
    if (nums.length) { return { core: nums, mods: ctx, nums: [] }; }                // "370"
    return { core: [], mods: ctx, nums: [] };                                         // "furniture": send as typed
  }

  function scopeTerm(word) {
    var terms = [];
    alternatives(word).forEach(function (a) {
      terms.push('title:' + a);
      if (TYPE_WORDS[a]) { terms.push('product_type:' + a); }
    });
    return terms.length === 1 ? terms[0] : '(' + terms.join(' OR ') + ')';
  }

  // "coffee table" -> "title:coffee title:table"; "king bed" -> "title:bed king".
  // Returns null when the query should be sent as typed: empty, a quoted phrase, advanced
  // syntax, or too long to AND sensibly.
  function scopedQuery(raw) {
    raw = (raw || '').trim().replace(/(\d)\s*(?:"|''|\u201d|\u2033)/g, '$1');   // 60" -> 60 (inch mark, not a phrase)
    if (!raw || /["():*]/.test(raw)) { return null; }
    var words = tokenize(raw);
    if (!words.length || words.length > 6) { return null; }
    var split = splitWords(words);
    if (!split.core.length) { return null; }
    var parts = split.core.map(scopeTerm);
    split.mods.forEach(function (m) {
      alternatives(m).forEach(function (a) { if (parts.indexOf(a) === -1) { parts.push(a); } });
    });
    return parts.join(' ');
  }

  function isSearchForm(form) {
    if (!form || form.tagName !== 'FORM') { return false; }
    var action = form.getAttribute('action') || '';
    return /(^|\/)search\/?$/.test(action.split('?')[0]);
  }

  // Serialise the form (keeps type=product etc.) with our own q.
  function searchUrl(form, raw) {
    var scoped = scopedQuery(raw);
    var params = [];
    var hasPrefix = false;
    var fields = form.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (!f.name || f.name === 'q' || f.disabled) { continue; }
      if ((f.type === 'checkbox' || f.type === 'radio') && !f.checked) { continue; }
      if (f.name === 'options[prefix]') {
        // the forms carry prefix=last for no-JS submits; it is not used with title: queries
        if (scoped) { continue; }
        hasPrefix = true;
      }
      params.push(encodeURIComponent(f.name) + '=' + encodeURIComponent(f.value));
    }
    params.push('q=' + encodeURIComponent(scoped ? SOBE_EXCL + scoped : raw));   // exclusion only on precise title: queries; it breaks plain prefix queries
    if (scoped) {
      params.push('sq=' + encodeURIComponent(raw));   // what the shopper typed, for display
      // Shopify's pagination links drop unknown parameters, so also remember it for this tab.
      try { window.sessionStorage.setItem('sobe_sq:' + (SOBE_EXCL + scoped).toLowerCase(), raw); } catch (err) { /* private mode */ }
    }
    if (!scoped && !hasPrefix) { params.push('options%5Bprefix%5D=last'); }
    var action = (form.getAttribute('action') || '/search').split('?')[0];
    return action + '?' + params.join('&');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isSearchForm(form)) { return; }
    var input = form.querySelector('input[name="q"]');
    if (!input) { return; }
    var raw = (input.value || '').trim();
    if (!raw) { return; }                       // empty search: let the theme/Shopify handle it
    e.preventDefault();
    window.location.href = searchUrl(form, raw);
  }, true);

  // On the results page, show exactly what the shopper typed (the sq parameter) instead of
  // the title: syntax. templates/search.liquid already prints a cleaned-up version server-side;
  // this restores the original word order and wording.
  function cleanTerms(s) {
    var seen = {};
    return (s || '')
      .replace(/-?vendor:(?:"[^"]*"|&quot;[\s\S]*?&quot;)/g, ' ')
      .replace(/\(\s*(?:title|product_type):([^\s)]+)(?:\s+OR\s+(?:title|product_type):[^\s)]+)*\s*\)/g, '$1')
      .replace(/\(|\)/g, ' ')
      .replace(/\bOR\b/g, ' ')
      .replace(/(?:title|product_type):/g, '')
      .replace(/\*/g, '')
      .split(/\s+/)
      .filter(function (w) { if (!w || seen[w]) { return false; } seen[w] = 1; return true; })
      .join(' ');
  }
  function paramFrom(search, name) {
    var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(search || '');
    if (!m) { return null; }
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (err) { return null; }
  }
  function queryParam(name) { return paramFrom(window.location.search, name); }
  function storedSq(q) {
    if (!q || q.indexOf('title:') === -1) { return null; }
    try { return window.sessionStorage.getItem('sobe_sq:' + q.toLowerCase()); } catch (err) { return null; }
  }
  function withParam(href, name, value) {
    var parts = href.split('#');
    var base = parts[0].replace(new RegExp('([?&])' + name + '=[^&]*&?'), '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') === -1 ? '?' : '&') + name + '=' + encodeURIComponent(value) + (parts[1] ? '#' + parts[1] : '');
  }
  function tidyResultsPage() {
    var currentQ = queryParam('q');
    var sq = queryParam('sq') || storedSq(currentQ);
    var i;
    var inputs = document.querySelectorAll('form input[name="q"]');
    for (i = 0; i < inputs.length; i++) {
      var v = inputs[i].value;
      if (sq && /search/.test(window.location.pathname)) {
        inputs[i].value = sq;
      } else if (v && /title:|product_type:|vendor:|\*/.test(v)) {
        inputs[i].value = cleanTerms(v);
      }
    }
    if (!sq) { return; }
    var spans = document.querySelectorAll('.sobe-sq');
    for (i = 0; i < spans.length; i++) { spans[i].textContent = sq; }
    // "Show all related results" = the plain query, in the shopper's own words
    var broad = document.querySelectorAll('.sobe-search-scope a');
    for (i = 0; i < broad.length; i++) { broad[i].href = withParam(broad[i].getAttribute('href'), 'q', sq); }
    // Page numbers, previous/next and "Show all (N)" keep the same scoped q but Shopify drops
    // sq from them: put it back on every link that repeats this exact search.
    var links = document.querySelectorAll('a[href*="search"]');
    for (i = 0; i < links.length; i++) {
      var h = links[i].getAttribute('href') || '';
      var qs = h.indexOf('?') === -1 ? '' : h.slice(h.indexOf('?'));
      if (currentQ && paramFrom(qs, 'q') === currentQ && h.indexOf('sq=') === -1) {
        links[i].href = withParam(h, 'sq', sq);
      }
    }
    if (document.title) {
      document.title = document.title.replace(/(["\u201c])[^"\u201d]*(["\u201d])/, '$1' + sq + '$2');
    }
    var crumbs = document.querySelectorAll('.breadcrumb > span:last-child');
    for (i = 0; i < crumbs.length; i++) {
      crumbs[i].textContent = crumbs[i].textContent.replace(/(["\u201c])[^"\u201d]*(["\u201d])/, '$1' + sq + '$2');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tidyResultsPage);
  } else {
    tidyResultsPage();
  }

  /* ------------------------------------------------------------------ type-ahead */

  // Exposed for testing (browser console / test harness) only.
  window.__sobeSearchDebug = { scopedQuery: scopedQuery, tokenize: tokenize };

  if (!window.fetch || !window.JSON || !document.querySelector) { return; }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 140;
  var MAX_PRODUCTS = 6;
  var MAX_QUERIES = 4;
  var MAX_COLLECTIONS = 3;
  var uid = 0;
  var cache = {};

  injectStyles();

  function injectStyles() {
    var css = [
      // z-index at the maximum: the floating accessibility (2147483646) and chat buttons sit very high
      '.sobe-ps{position:fixed;z-index:2147483647;background:#fff;color:#111;border:1px solid #e3e3e3;border-radius:10px;',
      'box-shadow:0 14px 40px rgba(0,0,0,.14),0 2px 8px rgba(0,0,0,.06);overflow-y:auto;overscroll-behavior:contain;',
      'font-size:14px;line-height:1.35;text-align:left;-webkit-overflow-scrolling:touch}',
      '.sobe-ps[hidden]{display:none!important}',
      '.sobe-ps ul{list-style:none;margin:0;padding:0}',
      '.sobe-ps .sobe-ps__opt{margin:0;padding:0}',
      '.sobe-ps__group{padding:6px 0;border-top:1px solid #efefef}',
      '.sobe-ps__group:first-child{border-top:0}',
      '.sobe-ps .sobe-ps__heading{margin:0;padding:8px 16px 4px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:#6b6b6b;font-weight:600}',
      '.sobe-ps__opt{cursor:pointer}',
      '.sobe-ps__link{display:flex;align-items:center;gap:12px;padding:8px 16px;color:inherit;text-decoration:none!important;border:0}',
      '@media (hover:hover){.sobe-ps__link:hover{background:#f7f7f5}}',
      // keyboard selection: a solid bar, not just a faint tint (visible in forced-colors mode too)
      '.sobe-ps__opt[aria-selected="true"] .sobe-ps__link{background:#ecebe6;box-shadow:inset 3px 0 0 #111}',
      '@media (forced-colors:active){.sobe-ps__opt[aria-selected="true"] .sobe-ps__link{outline:2px solid Highlight;outline-offset:-2px;box-shadow:none}}',
      '.sobe-ps__query .sobe-ps__link{padding-top:7px;padding-bottom:7px}',
      '.sobe-ps__query svg{flex:0 0 14px;width:14px;height:14px;color:#707070}',
      '.sobe-ps__img{flex:0 0 52px;width:52px;height:52px;border-radius:6px;background:#f2f2f0;object-fit:contain}',
      '.sobe-ps__txt{min-width:0;flex:1 1 auto}',
      '.sobe-ps__title{display:block;color:#111;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}',
      '.sobe-ps__price{display:block;margin-top:2px;font-size:13px;color:#666}',
      '.sobe-ps__price s{color:#707070;margin-right:6px}',
      '.sobe-ps__quote{font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#6b6b6b}',
      '.sobe-ps__soldout{color:#6b6b6b;margin-left:6px;font-size:12px}',
      '.sobe-ps__label{flex:0 0 auto;font-size:11px;color:#707070;letter-spacing:.06em;text-transform:uppercase}',
      '.sobe-ps mark{background:none;color:inherit;font-weight:700;padding:0}',
      '.sobe-ps__all .sobe-ps__link{justify-content:space-between;font-weight:600;padding-top:12px;padding-bottom:12px}',
      '.sobe-ps__empty{padding:14px 16px;color:#666}',
      '@media (max-width:589px){.sobe-ps{border-radius:0 0 10px 10px;font-size:15px}.sobe-ps__img{flex-basis:56px;width:56px;height:56px}}',
      '@media (prefers-reduced-motion:no-preference){.sobe-ps{animation:sobePsIn .12s ease-out}}',
      '@keyframes sobePsIn{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}'
    ].join('');
    var style = document.createElement('style');
    style.setAttribute('data-sobe-search', '');
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  // Attach lazily the first time a search box gets focus, so it also works for boxes the
  // theme renders later (e.g. the header search drawer).
  function attach(input) {
    if (!input || input.tagName !== 'INPUT' || input.name !== 'q') { return; }
    if (!isSearchForm(input.form)) { return; }
    if (!input.__sobePs) { input.__sobePs = new Typeahead(input); }
  }
  document.addEventListener('focusin', function (e) { attach(e.target); });

  // The header drawer traps focus (slate.a11y.trapFocus listens for focusin on document) and
  // would yank a screen reader's focus back out of the panel, which lives in <body>.
  function keepFocusInPanel(e) {
    if (e.target && e.target.nodeType === 1 && closest(e.target, '.sobe-ps')) { e.stopPropagation(); }
  }
  window.addEventListener('focusin', keepFocusInPanel, true);
  window.addEventListener('focus', keepFocusInPanel, true);   // jQuery may emulate focusin with capturing focus

  function Typeahead(input) {
    var self = this;
    this.input = input;
    this.form = input.form;
    this.id = 'sobe-ps-' + (++uid);
    this.items = [];          // [{el, kind, href, text}]
    this.active = -1;
    this.timer = null;
    this.controller = null;
    this.lastQuery = null;
    this.escClosed = false;
    this.blurTimer = null;
    this.seq = 0;             // request counter: answers to cancelled requests are ignored
    this.retryTimer = null;
    this.liveMsg = '';
    this.raf = 0;

    var panel = document.createElement('div');
    panel.className = 'sobe-ps';
    panel.id = this.id;
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Search suggestions');
    document.body.appendChild(panel);
    this.panel = panel;

    var live = document.createElement('div');
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    live.style.cssText = 'position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
    document.body.appendChild(live);
    this.live = live;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', this.id);
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');

    input.addEventListener('input', function () {
      self.setActive(-1, false);   // Enter must search what is typed now, not an older highlight
      self.schedule();
    });
    input.addEventListener('focus', function () {
      clearTimeout(self.blurTimer);
      if ((input.value || '').trim().length >= MIN_CHARS) { self.schedule(true); }
    });
    input.addEventListener('blur', function (e) {
      if (e.relatedTarget && self.panel.contains(e.relatedTarget)) { return; }   // screen reader moved into the list
      // delay so a tap on a suggestion still registers on touch screens
      self.blurTimer = setTimeout(function () { self.close(); }, 200);
    });
    panel.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (to && (to === input || panel.contains(to))) { return; }
      self.blurTimer = setTimeout(function () { self.close(); }, 200);
    });
    input.addEventListener('keydown', function (e) { self.onKeydown(e); });
    input.addEventListener('keyup', function (e) {
      // The theme closes the whole search drawer on Esc keyup. If this Esc only closed the
      // dropdown, stop it there so a second Esc is needed to close the drawer.
      if ((e.key === 'Escape' || e.keyCode === 27) && self.escClosed) {
        self.escClosed = false;
        e.stopPropagation();
      }
    });

    // Keep focus in the input when clicking inside the panel (otherwise blur closes it first).
    // Every option is a real link with its final URL, so clicks, middle-clicks and
    // ctrl/cmd-clicks navigate natively; hover only tints (it never changes what Enter does).
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });

    this.onReposition = function () { if (!self.panel.hidden) { self.position(); } };
    window.addEventListener('resize', this.onReposition);
    window.addEventListener('scroll', this.onReposition, true);
    if (window.visualViewport) {
      // on phones the keyboard only shrinks the visual viewport (no window resize)
      window.visualViewport.addEventListener('resize', this.onReposition);
      window.visualViewport.addEventListener('scroll', this.onReposition);
    }
    // back/forward cache restores a page with the panel still drawn; a normal load must not
    // close suggestions the shopper is already typing into
    window.addEventListener('pageshow', function (e) { if (e.persisted) { self.close(); } });

    // Attached during the focus that created us, so the focus listener above missed it.
    if (document.activeElement === input && (input.value || '').trim().length >= MIN_CHARS) {
      this.schedule(true);
    }
  }

  Typeahead.prototype.schedule = function (immediate) {
    var self = this;
    clearTimeout(this.timer);
    var q = (this.input.value || '').trim();
    if (q.length < MIN_CHARS) { this.abort(); this.close(); this.lastQuery = null; return; }
    this.timer = setTimeout(function () { self.fetch(q); }, immediate ? 0 : DEBOUNCE_MS);
  };

  Typeahead.prototype.abort = function () {
    if (this.controller) { try { this.controller.abort(); } catch (err) { /* ignore */ } }
    this.controller = null;
  };

  function isEmpty(res) {
    return !((res.products && res.products.length) || (res.queries && res.queries.length) ||
             (res.collections && res.collections.length));
  }

  Typeahead.prototype.fetch = function (q, retry) {
    var self = this;
    var key = q.toLowerCase();
    if (!retry && key === this.lastQuery && !this.panel.hidden) { return; }
    this.lastQuery = key;
    if (cache[key]) { this.render(q, cache[key]); return; }
    this.abort();
    var seq = ++this.seq;
    var controller = window.AbortController ? new AbortController() : null;
    this.controller = controller;
    // unavailable_products=show: quote-only pieces hold 0 stock on purpose and must keep their rank
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=query,collection,product' +
      '&resources[limit]=10&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=show' + (retry ? '&_r=1' : '');
    window.fetch(url, { credentials: 'same-origin', signal: controller ? controller.signal : undefined,
                        headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); })
      .then(function (json) {
        var res = (json && json.resources && json.resources.results) || {};
        var empty = isEmpty(res);
        // Shopify occasionally answers a first request with nothing ("couch" came back empty,
        // then full a moment later): never cache an empty answer, and ask once more.
        if (!empty) { cache[key] = res; }
        // ignore answers to cancelled requests (Esc/Tab/close) and stale ones (user kept typing)
        if (seq !== self.seq) { return; }
        if ((self.input.value || '').trim().toLowerCase() !== key) { return; }
        self.render(q, res);
        if (empty && !retry && key.length >= 3) {
          clearTimeout(self.retryTimer);
          self.retryTimer = setTimeout(function () {
            // not if the shopper closed the panel (Esc/Tab) or kept typing meanwhile
            if (seq !== self.seq || self.panel.hidden) { return; }
            if ((self.input.value || '').trim().toLowerCase() === key && document.activeElement === self.input) {
              self.fetch(q, true);
            }
          }, 450);
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') { return; }
        if (seq === self.seq) { self.close(); }   // suggestions are optional; Enter still searches normally
      });
  };

  /* --- matching helpers --- */

  function titleWords(title) {
    return (title || '').toLowerCase().replace(/[^a-z0-9\u00c0-\u024f]+/g, ' ').trim().split(/\s+/);
  }

  function titleHas(words, token) {
    return alternatives(token).some(function (a) {
      return words.some(function (w) { return w.indexOf(a) === 0; });
    });
  }

  // Every name word (or a synonym) starts some word of the title. Size/colour/material words
  // only rank, exactly like the results page.
  function titleMatchesAll(title, tokens) {
    if (!tokens.length) { return false; }
    var words = titleWords(title);
    return splitWords(tokens).core.every(function (t) { return titleHas(words, t); });
  }

  function modifierHits(title, tokens) {
    var words = titleWords(title);
    var sp = splitWords(tokens);
    return sp.mods.concat(sp.nums).filter(function (t) { return titleHas(words, t); }).length;
  }

  // Bold the parts of `text` that start with a typed word.
  function highlight(parent, text, tokens) {
    var prefixes = [];
    tokens.forEach(function (t) { alternatives(t).forEach(function (a) { prefixes.push(a); }); });
    prefixes.sort(function (a, b) { return b.length - a.length; });
    var re = /[A-Za-z0-9\u00c0-\u024f]+/g;
    var last = 0;
    var m;
    while ((m = re.exec(text)) !== null) {
      var word = m[0];
      var lower = word.toLowerCase();
      var hit = 0;
      for (var i = 0; i < prefixes.length; i++) {
        if (prefixes[i] && lower.indexOf(prefixes[i]) === 0) { hit = prefixes[i].length; break; }
      }
      if (!hit) { continue; }
      if (m.index > last) { parent.appendChild(document.createTextNode(text.slice(last, m.index))); }
      var mark = document.createElement('mark');
      mark.textContent = word.slice(0, hit);
      parent.appendChild(mark);
      parent.appendChild(document.createTextNode(word.slice(hit)));
      last = m.index + word.length;
    }
    if (last < text.length) { parent.appendChild(document.createTextNode(text.slice(last))); }
  }

  function formatMoney(amount) {
    var n = Number(amount);
    if (!isFinite(n)) { return ''; }
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    var two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var comma = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (all, key) {
      if (key === 'amount_no_decimals') { return none; }
      if (key === 'amount_with_comma_separator') { return comma; }
      return two;
    });
    var tmp = document.createElement('div');
    tmp.innerHTML = out;               // money_format may contain entities/markup from the theme
    return tmp.textContent || tmp.innerText || out;
  }

  function hidden(text) {
    var v = document.createElement('span');
    v.className = 'visually-hidden';
    v.style.cssText = 'position:absolute!important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
    v.textContent = text;
    return v;
  }

  // Same rules, in the same order, as snippets/product-grid-item.liquid (lines 1-16, 118-133).
  function priceNode(p) {
    var span = document.createElement('span');
    span.className = 'sobe-ps__price';
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var min = Number(p.price_min != null ? p.price_min : p.price);
    var max = Number(p.price_max != null ? p.price_max : p.price);
    if (tags.indexOf('starting-at') !== -1 && min > 0) {
      span.textContent = 'Starting at ' + formatMoney(min);
      return span;
    }
    if (tags.indexOf('contact-for-price') !== -1) {
      span.className += ' sobe-ps__quote';
      span.textContent = 'Request a custom quote';
      return span;
    }
    if (!(min > 0)) { return null; }
    var cmp = Number(p.compare_at_price_min != null ? p.compare_at_price_min : (p.compare_at_price_max || 0));
    if (cmp > min) {
      span.appendChild(hidden('Regular price'));
      var s = document.createElement('s');
      s.textContent = formatMoney(cmp);
      span.appendChild(s);
      span.appendChild(hidden('Sale price'));
    }
    span.appendChild(document.createTextNode((min !== max ? 'From ' : '') + formatMoney(min)));
    if (p.available === false) {
      var so = document.createElement('span');
      so.className = 'sobe-ps__soldout';
      so.textContent = '\u00b7 Sold out';
      span.appendChild(so);
    }
    return span;
  }

  function imageUrl(p) {
    var src = (p.featured_image && p.featured_image.url) || p.image || '';
    if (!src) { return ''; }
    if (src.indexOf('//') === 0) { src = 'https:' + src; }
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  /* --- rendering --- */

  Typeahead.prototype.render = function (q, res) {
    var self = this;
    var tokens = tokenize(q);
    var panel = this.panel;
    panel.textContent = '';
    this.items = [];
    this.active = -1;
    this.input.removeAttribute('aria-activedescendant');

    var qLower = q.toLowerCase();
    var queries = (res.queries || []).filter(function (s) { return !/couture|jardin|incanto/i.test(s.text || ''); }).filter(function (s) {
      return s && s.text && s.text.toLowerCase() !== qLower;
    }).slice(0, MAX_QUERIES);
    var collections = (res.collections || []).filter(function (c) { return !/\/collections\/(couture-jardin-|premium-luxury-outdoor-furniture|incanto-)/.test(c.url || ''); }).slice(0, MAX_COLLECTIONS);
    var products = (res.products || []).filter(function (p) { return p.vendor !== 'Couture Jardin' && p.vendor !== 'Incanto'; });
    var strict = products.filter(function (p) { return titleMatchesAll(p.title, tokens); });
    if (strict.length) {
      // keep Shopify's order, but lift titles that also contain the size/colour words
      strict = strict.map(function (p, i) { return { p: p, i: i, h: modifierHits(p.title, tokens) }; })
        .sort(function (a, b) { return (b.h - a.h) || (a.i - b.i); })
        .map(function (x) { return x.p; });
    }
    products = (strict.length ? strict : products).slice(0, MAX_PRODUCTS);

    if (queries.length) {
      var gq = this.group('Suggestions');
      queries.forEach(function (s) {
        var li = self.option(gq, 'query', searchUrl(self.form, s.text), s.text);
        li.classList.add('sobe-ps__query');
        var a = li.firstChild;
        a.appendChild(searchIcon());
        var t = document.createElement('span');
        t.className = 'sobe-ps__txt';
        highlight(t, s.text, tokens);
        a.appendChild(t);
      });
    }

    if (collections.length) {
      var gc = this.group('Collections');
      collections.forEach(function (c) {
        var li = self.option(gc, 'link', c.url, c.title);
        var a = li.firstChild;
        var t = document.createElement('span');
        t.className = 'sobe-ps__txt';
        highlight(t, c.title, tokens);
        a.appendChild(t);
        var lab = document.createElement('span');
        lab.className = 'sobe-ps__label';
        lab.textContent = 'Shop all';
        a.appendChild(lab);
      });
    }

    if (products.length) {
      var gp = this.group('Products');
      products.forEach(function (p) {
        var li = self.option(gp, 'link', p.url, p.title);
        var a = li.firstChild;
        var src = imageUrl(p);
        if (src) {
          var img = document.createElement('img');
          img.className = 'sobe-ps__img';
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 52;
          img.height = 52;
          a.appendChild(img);
        }
        var txt = document.createElement('span');
        txt.className = 'sobe-ps__txt';
        var title = document.createElement('span');
        title.className = 'sobe-ps__title';
        highlight(title, p.title, tokens);
        txt.appendChild(title);
        var price = priceNode(p);
        if (price) { txt.appendChild(price); }
        a.appendChild(txt);
      });
    }

    var nothing = !queries.length && !collections.length && !products.length;
    if (nothing) {
      var empty = document.createElement('div');
      empty.className = 'sobe-ps__empty';
      empty.textContent = 'No quick matches \u2014 search to see all results.';
      panel.appendChild(empty);
    }

    // Always offer the full search as the last option.
    var ga = document.createElement('ul');
    ga.className = 'sobe-ps__group sobe-ps__all';
    ga.setAttribute('role', 'group');
    ga.setAttribute('aria-label', 'Search');
    panel.appendChild(ga);
    var allLi = this.option(ga, 'search', searchUrl(this.form, q), q);
    var allA = allLi.firstChild;
    var lbl = document.createElement('span');
    lbl.textContent = 'Search for \u201c' + q + '\u201d';
    allA.appendChild(lbl);
    allA.appendChild(arrowIcon());

    // Announce once per change, counting every suggestion (not just products).
    var n = this.items.length - 1;
    var msg = nothing ? 'No suggestions. Search to see all results.'
                      : n + ' suggestion' + (n === 1 ? '' : 's') + ' available.';
    if (msg !== this.liveMsg) { this.liveMsg = msg; this.live.textContent = msg; }
    this.open();
  };

  Typeahead.prototype.group = function (heading) {
    var hid = this.id + '-h' + this.panel.children.length;
    var ul = document.createElement('ul');
    ul.className = 'sobe-ps__group';
    ul.setAttribute('role', 'group');
    ul.setAttribute('aria-labelledby', hid);
    var h = document.createElement('li');
    h.className = 'sobe-ps__heading';
    h.id = hid;
    h.setAttribute('role', 'presentation');
    h.textContent = heading;
    ul.appendChild(h);
    this.panel.appendChild(ul);
    return ul;
  };

  Typeahead.prototype.option = function (ul, kind, href, text) {
    var index = this.items.length;
    var li = document.createElement('li');
    li.className = 'sobe-ps__opt';
    li.id = this.id + '-o' + index;
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.setAttribute('data-index', String(index));
    var a = document.createElement('a');
    a.className = 'sobe-ps__link';
    a.tabIndex = -1;
    a.href = href;
    li.appendChild(a);
    ul.appendChild(li);
    this.items.push({ el: li, kind: kind, href: a.href, text: text });
    return li;
  };

  Typeahead.prototype.setActive = function (index, scroll) {
    if (this.active === index) { return; }
    if (this.active > -1 && this.items[this.active]) {
      this.items[this.active].el.setAttribute('aria-selected', 'false');
    }
    this.active = index;
    var item = this.items[index];
    if (!item) { this.input.removeAttribute('aria-activedescendant'); return; }
    item.el.setAttribute('aria-selected', 'true');
    this.input.setAttribute('aria-activedescendant', item.el.id);
    if (scroll !== false && item.el.scrollIntoView) { item.el.scrollIntoView({ block: 'nearest' }); }
  };

  Typeahead.prototype.choose = function (index) {
    var item = this.items[index];
    if (!item) { return; }
    if (item.kind === 'query' || item.kind === 'search') { this.input.value = item.text; }
    this.close();
    window.location.href = item.href;   // query/search rows already hold the precise search URL
  };

  Typeahead.prototype.onKeydown = function (e) {
    var key = e.key || '';
    var open = !this.panel.hidden && this.items.length;
    if (key === 'ArrowDown' || key === 'Down') {
      if (!open) { this.schedule(true); return; }
      e.preventDefault();
      this.setActive(this.active + 1 >= this.items.length ? 0 : this.active + 1);
    } else if (key === 'ArrowUp' || key === 'Up') {
      if (!open) { return; }
      e.preventDefault();
      this.setActive(this.active - 1 < 0 ? this.items.length - 1 : this.active - 1);
    } else if (key === 'Enter') {
      if (open && this.active > -1) { e.preventDefault(); this.choose(this.active); }
      // otherwise the form submits and the submit handler above does the rest
    } else if (key === 'Escape' || key === 'Esc') {
      if (!this.panel.hidden) {
        e.preventDefault();
        this.escClosed = true;
        this.close();
      }
    } else if (key === 'Tab') {
      this.close();
    }
  };

  Typeahead.prototype.position = function () {
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var anchor = this.form || this.input;
    var r = anchor.getBoundingClientRect();
    var ir = this.input.getBoundingClientRect();
    var gutter = vw < 590 ? 0 : 12;
    var width;
    var left;
    if (vw < 590) {
      left = 0;
      width = vw;
    } else {
      width = Math.max(360, Math.min(r.width, 680));
      left = Math.max(gutter, Math.min(r.left, vw - width - gutter));
    }
    var top = Math.max(r.bottom, ir.bottom) + (vw < 590 ? 0 : 6);
    // The on-screen keyboard only shrinks the visual viewport; size the list to what is visible
    // so its last rows (and "Search for ...") are never stuck under the keyboard.
    var vv = window.visualViewport;
    var visTop = vv ? vv.offsetTop : 0;
    var visBottom = vv ? Math.min(vh, vv.offsetTop + vv.height) : vh;
    // hidden or scrolled off-screen anchor: nothing sensible to attach to
    if (r.width === 0 && r.height === 0) { this.close(); return; }
    if (r.bottom < visTop || r.top > visBottom) { this.panel.style.visibility = 'hidden'; return; }
    this.panel.style.visibility = '';
    this.panel.style.left = left + 'px';
    this.panel.style.top = top + 'px';
    this.panel.style.width = width + 'px';
    this.panel.style.maxHeight = Math.max(120, visBottom - top - 8) + 'px';
  };

  // Follow the search box while the panel is open: the header drawer slides in, the sticky
  // header shrinks and the keyboard opens after the first render, and none of these fire
  // resize/scroll. Reads the box position once per frame and only moves the panel on change.
  Typeahead.prototype.track = function () {
    var self = this;
    var last = '';
    if (window.cancelAnimationFrame) { window.cancelAnimationFrame(this.raf); }
    if (!window.requestAnimationFrame) { this.position(); return; }
    (function tick() {
      if (self.panel.hidden) { return; }
      var r = (self.form || self.input).getBoundingClientRect();
      var vv = window.visualViewport;
      var sig = r.top + '|' + r.bottom + '|' + r.left + '|' + r.width + '|' +
                (vv ? vv.height + '|' + vv.offsetTop : '');
      if (sig !== last) { last = sig; self.position(); }
      self.raf = window.requestAnimationFrame(tick);
    })();
  };

  Typeahead.prototype.open = function () {
    if (document.activeElement !== this.input) { this.close(); return; }
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.track();
  };

  Typeahead.prototype.close = function () {
    clearTimeout(this.timer);
    clearTimeout(this.retryTimer);
    this.seq++;                 // an answer still in flight must not reopen the panel
    this.abort();
    if (window.cancelAnimationFrame) { window.cancelAnimationFrame(this.raf); }
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
    if (this.active > -1 && this.items[this.active]) {
      this.items[this.active].el.setAttribute('aria-selected', 'false');
    }
    this.active = -1;
    this.lastQuery = null;
  };

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(sel) : el.msMatchesSelector(sel)) { return el; }
      el = el.parentElement;
    }
    return null;
  }

  function svg(path) {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', path);
    s.appendChild(p);
    return s;
  }
  function searchIcon() { return svg('M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10 2-4.35-4.35'); }
  function arrowIcon() {
    var s = svg('M5 12h14M13 6l6 6-6 6');
    s.setAttribute('width', '16');
    s.setAttribute('height', '16');
    return s;
  }

  window.__sobeSearchDebug.titleMatchesAll = titleMatchesAll;

  // A shopper may already be in the box when this deferred script runs (slow phones).
  attach(document.activeElement);
})();
